// src/screens/ResponsesScreen.css.js - VERSÃO ATUALIZADA E COMPLETA
import { StyleSheet } from 'react-native';
import { AVAQualisTheme } from '../theme/theme';

export const styles = StyleSheet.create({
  // Container principal
  container: {
    flex: 1,
    backgroundColor: AVAQualisTheme.colors.background,
  },
  appbar: {
    backgroundColor: AVAQualisTheme.colors.primary,
    elevation: 4,
  },
  appbarTitle: {
    color: AVAQualisTheme.colors.onPrimary,
    fontWeight: 'bold',
    fontSize: 18,
  },
  appbarSubtitle: {
    color: AVAQualisTheme.colors.onPrimary,
    opacity: 0.9,
    fontSize: 12,
  },
  content: {
    flex: 1,
    paddingHorizontal: AVAQualisTheme.spacing.md,
    paddingTop: AVAQualisTheme.spacing.md,
  },
  
  // Status do servidor
  serverStatusContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: AVAQualisTheme.spacing.md,
    paddingVertical: AVAQualisTheme.spacing.sm,
    backgroundColor: AVAQualisTheme.colors.surface,
    marginBottom: AVAQualisTheme.spacing.sm,
    borderBottomWidth: 1,
    borderBottomColor: AVAQualisTheme.colors.outline,
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: AVAQualisTheme.spacing.xs,
  },
  serverStatusLabel: {
    fontSize: 14,
    fontWeight: '600',
    color: AVAQualisTheme.colors.secondary,
  },
  serverStatusChecking: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: AVAQualisTheme.spacing.xs,
  },
  serverStatusCheckingText: {
    fontSize: 12,
    color: AVAQualisTheme.colors.primary,
    fontWeight: '500',
  },
  serverStatusIndicator: {
    paddingVertical: 4,
    paddingHorizontal: 10,
    borderRadius: AVAQualisTheme.borderRadius.sm,
  },
  serverStatusText: {
    fontSize: 12,
    fontWeight: '600',
  },
  checkConnectionButton: {
    marginLeft: 'auto',
  },
  
  // Avaliador info - MELHORADO
  avaliadorInfoContainer: {
    backgroundColor: AVAQualisTheme.colors.surface,
    padding: AVAQualisTheme.spacing.md,
    marginBottom: AVAQualisTheme.spacing.md,
    borderRadius: AVAQualisTheme.borderRadius.md,
    borderLeftWidth: 3,
    borderLeftColor: AVAQualisTheme.colors.primary,
    marginHorizontal: AVAQualisTheme.spacing.md,
  },
  avaliadorInfoHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 6,
  },
  avaliadorInfoTitle: {
    fontSize: 12,
    fontWeight: '600',
    color: AVAQualisTheme.colors.secondary,
  },
  avaliadorInfoLevelChip: {
    backgroundColor: `${AVAQualisTheme.colors.primary}10`,
    height: 24,
  },
  avaliadorInfoLevelChipText: {
    fontSize: 11,
    fontWeight: '600',
    color: AVAQualisTheme.colors.primary,
  },
  avaliadorInfoName: {
    fontSize: 16,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
    marginBottom: 2,
  },
  avaliadorInfoEmail: {
    fontSize: 14,
    color: AVAQualisTheme.colors.secondary,
    marginBottom: 8,
  },
  avaliadorInfoNote: {
    fontSize: 11,
    fontStyle: 'italic',
    color: AVAQualisTheme.colors.error,
    marginTop: 4,
  },
  
  // NOVO: Legenda de status
  legendContainer: {
    paddingHorizontal: AVAQualisTheme.spacing.md,
    marginBottom: AVAQualisTheme.spacing.sm,
    backgroundColor: AVAQualisTheme.colors.surface,
    padding: AVAQualisTheme.spacing.sm,
    borderRadius: AVAQualisTheme.borderRadius.md,
    marginHorizontal: AVAQualisTheme.spacing.md,
  },
  legendTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 4,
    color: AVAQualisTheme.colors.secondary,
  },
  legendItems: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  legendItem: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '48%',
    marginVertical: 2,
  },
  legendColorBox: {
    width: 12,
    height: 12,
    borderRadius: 3,
    marginRight: 4,
  },
  legendText: {
    fontSize: 10,
    color: AVAQualisTheme.colors.secondary,
  },
  
  // NOVO: Filtros
  filtersContainer: {
    paddingHorizontal: AVAQualisTheme.spacing.md,
    marginBottom: AVAQualisTheme.spacing.md,
  },
  filtersScrollContent: {
    paddingBottom: 4,
    flexDirection: 'row',
    gap: 8,
  },
  filterButton: {
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderRadius: AVAQualisTheme.borderRadius.md,
    backgroundColor: AVAQualisTheme.colors.surfaceVariant,
    borderWidth: 1,
    borderColor: AVAQualisTheme.colors.outline,
  },
  activeFilterButton: {
    backgroundColor: AVAQualisTheme.colors.primary,
    borderColor: AVAQualisTheme.colors.primary,
  },
  filterButtonText: {
    fontSize: 13,
    fontWeight: '600',
    color: AVAQualisTheme.colors.secondary,
  },
  activeFilterButtonText: {
    color: AVAQualisTheme.colors.onPrimary,
  },
  
  // Filtros específicos por status
  cloudNewerFilterButton: {
    backgroundColor: '#FFEBEE',
    borderColor: '#D32F2F',
  },
  activeCloudNewerFilterButton: {
    backgroundColor: '#D32F2F',
    borderColor: '#D32F2F',
  },
  cloudNewerFilterButtonText: {
    color: '#D32F2F',
  },
  
  localNewerFilterButton: {
    backgroundColor: '#FFF8E1',
    borderColor: '#FF6F00',
  },
  activeLocalNewerFilterButton: {
    backgroundColor: '#FF6F00',
    borderColor: '#FF6F00',
  },
  localNewerFilterButtonText: {
    color: '#FF6F00',
  },
  
  localOnlyFilterButton: {
    backgroundColor: '#FFECB3',
    borderColor: '#FF8F00',
  },
  activeLocalOnlyFilterButton: {
    backgroundColor: '#FF8F00',
    borderColor: '#FF8F00',
  },
  localOnlyFilterButtonText: {
    color: '#FF8F00',
  },
  
  syncedFilterButton: {
    backgroundColor: '#E8F5E9',
    borderColor: '#2E7D32',
  },
  activeSyncedFilterButton: {
    backgroundColor: '#2E7D32',
    borderColor: '#2E7D32',
  },
  syncedFilterButtonText: {
    color: '#2E7D32',
  },
  
  // Estatísticas
  statsContainer: {
    paddingHorizontal: AVAQualisTheme.spacing.md,
    marginBottom: AVAQualisTheme.spacing.md,
  },
  statsCard: {
    borderRadius: AVAQualisTheme.borderRadius.lg,
    ...AVAQualisTheme.shadows.medium,
  },
  statsRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'stretch',
  },
  stat: {
    flex: 1,
    alignItems: 'center',
    padding: AVAQualisTheme.spacing.sm,
  },
  statHeader: {
    marginBottom: 4,
  },
  statNumber: {
    fontSize: 28,
    fontWeight: 'bold',
  },
  statLabel: {
    fontSize: 14,
    color: AVAQualisTheme.colors.secondary,
    marginBottom: 8,
  },
  statsDivider: {
    width: 1,
    height: '80%',
    alignSelf: 'center',
  },
  statDetailText: {
    fontSize: 11,
    color: AVAQualisTheme.colors.secondary,
    marginTop: 2,
  },
  pendingChipContainer: {
    backgroundColor: `${AVAQualisTheme.colors.warning}15`,
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: AVAQualisTheme.borderRadius.sm,
  },
  pendingChipText: {
    fontSize: 12,
    fontWeight: '600',
    color: AVAQualisTheme.colors.warning,
  },
  syncedChipContainer: {
    backgroundColor: `${AVAQualisTheme.colors.success}15`,
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: AVAQualisTheme.borderRadius.sm,
  },
  syncedChipText: {
    fontSize: 12,
    fontWeight: '600',
    color: AVAQualisTheme.colors.success,
  },
  
  // Cards de resposta
  responsesListContainer: {
    gap: AVAQualisTheme.spacing.md,
  },
  responseCard: {
    marginBottom: AVAQualisTheme.spacing.md,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    ...AVAQualisTheme.shadows.medium,
    borderLeftWidth: 4,
  },
  // Estilos específicos por status
  syncedCard: {
    borderLeftColor: '#2E7D32',
    backgroundColor: '#FAFFFE',
  },
  cloudNewerCard: {
    borderLeftColor: '#D32F2F',
    backgroundColor: '#FFFAFA',
  },
  localNewerCard: {
    borderLeftColor: '#FF6F00',
    backgroundColor: '#FFFCF5',
  },
  localOnlyCard: {
    borderLeftColor: '#FF8F00',
    backgroundColor: '#FFFDF7',
  },
  
  // Header do card
  responseHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: AVAQualisTheme.spacing.sm,
  },
  titleSection: {
    flex: 1,
    marginRight: AVAQualisTheme.spacing.sm,
  },
  responseTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 4,
  },
  // Cores de título por status
  syncedTitle: {
    color: '#2E7D32',
  },
  cloudNewerTitle: {
    color: '#D32F2F',
  },
  localNewerTitle: {
    color: '#FF6F00',
  },
  localOnlyTitle: {
    color: '#FF8F00',
  },
  
  // Datas e IDs
  responseDate: {
    fontSize: 12,
    color: AVAQualisTheme.colors.secondary,
    marginBottom: 2,
  },
  syncDate: {
    fontSize: 12,
    color: '#2E7D32',
    fontWeight: '500',
    marginBottom: 2,
  },
  cloudNewerDate: {
    fontSize: 12,
    color: '#D32F2F',
    fontWeight: '500',
    marginBottom: 2,
  },
  responseId: {
    fontSize: 10,
    color: '#999',
  },
  
  // Badge de status
  statusBadge: {
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderRadius: AVAQualisTheme.borderRadius.md,
    minWidth: 90,
    alignItems: 'center',
  },
  statusBadgeText: {
    fontSize: 12,
    fontWeight: '600',
  },
  
  // NOVOS ESTILOS: Indicador de progresso aprimorado
  progressIndicatorContainer: {
    marginVertical: 12,
    padding: 12,
    borderRadius: AVAQualisTheme.borderRadius.md,
    borderLeftWidth: 4,
  },
  progressHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 6,
  },
  progressPercentage: {
    fontSize: 15,
    fontWeight: '500',
  },
  progressPercentageBold: {
    fontSize: 17,
    fontWeight: 'bold',
  },
  progressFraction: {
    fontSize: 15,
    fontWeight: '500',
  },
  progressBoldNumber: {
    fontSize: 17,
    fontWeight: 'bold',
  },
  progressBarContainer: {
    height: 10,
    marginVertical: 6,
    overflow: 'hidden',
  },
  progressBarTrack: {
    flex: 1,
    height: 10,
    borderRadius: 5,
  },
  progressBarFill: {
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    borderRadius: 5,
  },
  progressStatusText: {
    fontSize: 13,
    marginTop: 6,
    fontStyle: 'italic',
  },
  
  // Contêiner para aviso de servidor offline
  offlineWarningContainer: {
    marginTop: 4,
    padding: 8,
    backgroundColor: `${AVAQualisTheme.colors.error}15`,
    borderRadius: AVAQualisTheme.borderRadius.sm,
  },
  offlineWarning: {
    fontSize: 12,
    color: AVAQualisTheme.colors.error,
    fontWeight: '500',
  },
  
  // Resumo das respostas
  summaryContainer: {
    marginVertical: 8,
    borderWidth: 1,
    borderColor: '#E0E0E0',
    borderRadius: AVAQualisTheme.borderRadius.md,
    overflow: 'hidden',
  },
  summaryHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 8,
    backgroundColor: '#F5F5F5',
  },
  summaryHeaderText: {
    fontSize: 13,
    fontWeight: '600',
    color: AVAQualisTheme.colors.secondary,
  },
  summaryExpandIcon: {
    fontSize: 14,
    color: AVAQualisTheme.colors.secondary,
  },
  summaryContent: {
    padding: 10,
    backgroundColor: '#FAFAFA',
  },
  summaryText: {
    fontSize: 13,
    color: AVAQualisTheme.colors.onSurface,
    fontFamily: 'monospace',
    lineHeight: 20,
  },
  
  // Anexos
  attachmentsPreview: {
    backgroundColor: `${AVAQualisTheme.colors.info}08`,
    padding: AVAQualisTheme.spacing.sm,
    borderRadius: AVAQualisTheme.borderRadius.md,
    marginBottom: AVAQualisTheme.spacing.sm,
    borderLeftWidth: 3,
    borderLeftColor: AVAQualisTheme.colors.info,
  },
  attachmentsPreviewTitle: {
    fontSize: 12,
    fontWeight: '600',
    color: AVAQualisTheme.colors.info,
    marginBottom: 2,
  },
  attachmentsPreviewText: {
    fontSize: 13,
    color: AVAQualisTheme.colors.secondary,
  },
  
  // Avaliador
  avaliadorPreview: {
    backgroundColor: `${AVAQualisTheme.colors.primary}08`,
    padding: AVAQualisTheme.spacing.sm,
    borderRadius: AVAQualisTheme.borderRadius.md,
    marginBottom: AVAQualisTheme.spacing.sm,
    borderLeftWidth: 3,
    borderLeftColor: AVAQualisTheme.colors.primary,
  },
  avaliadorPreviewTitle: {
    fontSize: 12,
    fontWeight: '600',
    color: AVAQualisTheme.colors.primary,
    marginBottom: 2,
  },
  avaliadorPreviewText: {
    fontSize: 13,
    color: AVAQualisTheme.colors.secondary,
  },
  avaliadorLevelText: {
    fontSize: 12,
    color: AVAQualisTheme.colors.tertiary,
    fontStyle: 'italic',
  },
  
  // Ações nos cards
  cardActions: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: AVAQualisTheme.spacing.sm,
    paddingBottom: AVAQualisTheme.spacing.sm,
    gap: AVAQualisTheme.spacing.xs,
    flexWrap: 'wrap',
  },
  deleteButton: {
    borderColor: AVAQualisTheme.colors.error,
  },
  deleteButtonSynced: {
    borderColor: AVAQualisTheme.colors.secondary,
  },
  editButton: {
    borderColor: AVAQualisTheme.colors.primary,
  },
  viewCloudButton: {
    borderColor: '#1976D2',
  },
  uploadButton: {
    minWidth: 140,
  },
  downloadButton: {
    backgroundColor: '#D32F2F',
    minWidth: 140,
  },
  localNewerUploadButton: {
    backgroundColor: '#FF6F00',
  },
  localOnlyUploadButton: {
    backgroundColor: '#FF8F00',
  },
  bounceHover: {
    transform: [{ scale: 1 }],
    // Em um ambiente real, seria implementado com Animated
  },
  
  // Botões flutuantes
  fabContainer: {
    position: 'absolute',
    bottom: 16,
    right: 16,
    zIndex: 10,
    alignItems: 'flex-end',
  },
  fab: {
    borderRadius: AVAQualisTheme.borderRadius.lg,
    ...AVAQualisTheme.shadows.large,
    paddingHorizontal: AVAQualisTheme.spacing.md,
    minWidth: 180,
  },
  uploadAllFab: {
    backgroundColor: '#FF8F00',
  },
  updateAllFab: {
    backgroundColor: '#FF6F00',
  },
  downloadAllFab: {
    backgroundColor: '#D32F2F',
  },
  fabLabel: {
    fontSize: 14,
    fontWeight: '600',
  },
  
  // Overlay de carregamento
  uploadOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 20,
  },
  uploadContent: {
    backgroundColor: AVAQualisTheme.colors.surface,
    padding: AVAQualisTheme.spacing.xl,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    alignItems: 'center',
    ...AVAQualisTheme.shadows.large,
    maxWidth: '80%',
  },
  uploadText: {
    color: AVAQualisTheme.colors.primary,
    marginTop: AVAQualisTheme.spacing.md,
    fontSize: 16,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  uploadSubtext: {
    color: AVAQualisTheme.colors.secondary,
    marginTop: AVAQualisTheme.spacing.xs,
    fontSize: 13,
    fontWeight: '500',
    textAlign: 'center',
  },
  
  // Estado vazio
  emptyCard: {
    backgroundColor: AVAQualisTheme.colors.surfaceVariant,
    borderStyle: 'dashed',
    borderWidth: 2,
    borderColor: AVAQualisTheme.colors.outline,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    marginTop: AVAQualisTheme.spacing.xl,
  },
  emptyContent: {
    alignItems: 'center',
    paddingVertical: AVAQualisTheme.spacing.xl,
  },
  emptyIcon: {
    fontSize: 64,
    marginBottom: AVAQualisTheme.spacing.md,
  },
  emptyTitle: {
    textAlign: 'center',
    marginBottom: AVAQualisTheme.spacing.sm,
    color: AVAQualisTheme.colors.primary,
    fontSize: 18,
  },
  emptyText: {
    textAlign: 'center',
    color: AVAQualisTheme.colors.secondary,
    lineHeight: 22,
    fontSize: 14,
    maxWidth: '85%',
    fontWeight: '500',
  },
  emptyActions: {
    justifyContent: 'center',
    paddingBottom: AVAQualisTheme.spacing.md,
  },
  emptyButton: {
    minWidth: 200,
  },
  
  // Sem resultados para o filtro
  noResultsCard: {
    backgroundColor: AVAQualisTheme.colors.surfaceVariant,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    marginTop: AVAQualisTheme.spacing.xl,
  },
  noResultsContent: {
    alignItems: 'center',
    paddingVertical: AVAQualisTheme.spacing.xl,
  },
  noResultsIcon: {
    fontSize: 48,
    marginBottom: AVAQualisTheme.spacing.md,
    color: AVAQualisTheme.colors.secondary,
  },
  noResultsTitle: {
    textAlign: 'center',
    marginBottom: AVAQualisTheme.spacing.sm,
    color: AVAQualisTheme.colors.secondary,
    fontSize: 18,
  },
  noResultsText: {
    textAlign: 'center',
    color: AVAQualisTheme.colors.secondary,
    lineHeight: 22,
    fontSize: 14,
    maxWidth: '85%',
    fontWeight: '500',
  },
  noResultsActions: {
    justifyContent: 'center',
    paddingBottom: AVAQualisTheme.spacing.md,
  },
  
  // Loading container
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  loadingText: {
    color: AVAQualisTheme.colors.primary,
    marginTop: AVAQualisTheme.spacing.md,
    fontSize: 16,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  // Estilos para badges de validação
  validationBadgeContainer: {
    marginTop: 8,
    marginBottom: 8,
  },
  validationBadge: {
    backgroundColor: '#4CAF50',
    borderRadius: 20,
    padding: 6,
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
    elevation: 2,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.2,
    shadowRadius: 2,
  },
  validationBadgeText: {
    fontSize: 12,
    fontWeight: 'bold',
    color: 'white',
    marginLeft: 6,
    marginRight: 4,
  },
  validationDetails: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 6,
    backgroundColor: '#E8F5E9',
    borderRadius: 8,
    padding: 8,
    borderWidth: 1,
    borderColor: '#4CAF50',
  },
  validationInfo: {
    marginLeft: 8,
    flex: 1,
  },
  validationInfoText: {
    fontSize: 11,
    color: '#2E7D32',
    fontWeight: '500',
  },
  validationByText: {
    fontSize: 10,
    color: '#558B2F',
    fontStyle: 'italic',
    marginTop: 2,
  },
  
  // Estilos para pendente de validação
  pendingValidationContainer: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginTop: 8,
    marginBottom: 8,
    backgroundColor: '#FFF8E1',
    borderRadius: 8,
    padding: 10,
    borderLeftWidth: 3,
    borderLeftColor: '#FF8F00',
  },
  pendingValidationInfo: {
    marginLeft: 8,
    flex: 1,
  },
  pendingValidationTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#FF6F00',
    marginBottom: 2,
  },
  pendingValidationText: {
    fontSize: 11,
    color: '#F57C00',
    lineHeight: 16,
  },
  
  // Botão de visualização para respostas validadas
  viewValidatedButton: {
    borderColor: AVAQualisTheme.colors.success,
    backgroundColor: '#f5f5f5',
  },
  // Espaçador
  bottomSpacer: {
    height: AVAQualisTheme.spacing.xl * 3, // Aumentado para acomodar múltiplos FABs
  },
  
  // Dialog
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  dialogContainer: {
    backgroundColor: AVAQualisTheme.colors.surface,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    minWidth: 300,
    maxWidth: '90%',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.25,
    shadowRadius: 12,
    elevation: 8,
  },
  dialogHeader: {
    paddingHorizontal: 24,
    paddingTop: 24,
    paddingBottom: 16,
  },
  dialogTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
  },
  dialogContent: {
    paddingHorizontal: 24,
    paddingBottom: 20,
  },
  dialogMessage: {
    fontSize: 16,
    lineHeight: 24,
    color: AVAQualisTheme.colors.onSurface,
  },
  dialogActions: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingHorizontal: 16,
    paddingBottom: 16,
    gap: 8,
  },
  dialogButton: {
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderRadius: AVAQualisTheme.borderRadius.md,
    minWidth: 80,
    alignItems: 'center',
    justifyContent: 'center',
  },
  dialogButtonSecondary: {
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: AVAQualisTheme.colors.outline,
  },
  dialogButtonPrimary: {
    backgroundColor: AVAQualisTheme.colors.primary,
  },
  dialogButtonText: {
    fontSize: 14,
    fontWeight: '600',
  },
  dialogButtonTextSecondary: {
    color: AVAQualisTheme.colors.primary,
  },
  dialogButtonTextPrimary: {
    color: AVAQualisTheme.colors.onPrimary,
  },
  
  // Modal de Conflito
  conflictModalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  conflictModalContainer: {
    backgroundColor: AVAQualisTheme.colors.surface,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    width: '90%',
    maxHeight: '80%',
    ...AVAQualisTheme.shadows.large,
  },
  conflictModalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 24,
    paddingTop: 24,
    paddingBottom: 16,
    borderBottomWidth: 1,
    borderBottomColor: AVAQualisTheme.colors.outline,
  },
  conflictModalTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
  },
  conflictModalContent: {
    paddingHorizontal: 24,
    paddingVertical: 16,
    maxHeight: 500,
  },
  conflictModalDescription: {
    fontSize: 15,
    lineHeight: 22,
    color: AVAQualisTheme.colors.secondary,
    marginBottom: 16,
  },
  conflictDatesContainer: {
    marginBottom: 16,
    backgroundColor: '#F5F5F5',
    borderRadius: AVAQualisTheme.borderRadius.md,
    padding: 12,
  },
  conflictDateItem: {
    marginBottom: 8,
    padding: 6,
    borderRadius: 4,
  },
  conflictDateItemHighlighted: {
    backgroundColor: 'rgba(0, 150, 136, 0.1)',
    borderLeftWidth: 2,
    borderLeftColor: '#009688',
  },
  conflictDateLabel: {
    fontSize: 13,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.secondary,
    marginBottom: 2,
  },
  conflictDateValue: {
    fontSize: 14,
    color: AVAQualisTheme.colors.onSurface,
  },
  conflictProgressValue: {
    fontSize: 13,
    color: AVAQualisTheme.colors.secondary,
    marginTop: 2,
  },
  conflictDivider: {
    marginVertical: 16,
  },
  conflictSectionTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
    marginBottom: 12,
  },
  conflictItem: {
    marginBottom: 16,
    borderWidth: 1,
    borderColor: '#E0E0E0',
    borderRadius: AVAQualisTheme.borderRadius.md,
    overflow: 'hidden',
  },
  conflictItemTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    backgroundColor: '#F5F5F5',
    padding: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#E0E0E0',
  },
  conflictItemContent: {
    padding: 12,
  },
  conflictItemLocal: {
    marginBottom: 12,
    paddingBottom: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#EEEEEE',
    padding: 6,
    borderRadius: 4,
  },
  conflictItemCloud: {
    padding: 6,
    borderRadius: 4,
  },
  conflictItemHighlighted: {
    backgroundColor: 'rgba(0, 150, 136, 0.1)',
    borderLeftWidth: 2,
    borderLeftColor: '#009688',
  },
  conflictItemLabel: {
    fontSize: 13,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.secondary,
    marginBottom: 4,
  },
  conflictItemValue: {
    fontSize: 14,
    color: AVAQualisTheme.colors.onSurface,
  },
  noConflictsText: {
    fontSize: 14,
    color: AVAQualisTheme.colors.secondary,
    fontStyle: 'italic',
    textAlign: 'center',
    padding: 20,
  },
  conflictModalActions: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 16,
    borderTopWidth: 1,
    borderTopColor: AVAQualisTheme.colors.outline,
  },
  conflictCloudButton: {
    flex: 1,
    marginRight: 8,
    borderColor: '#1976D2',
  },
  conflictLocalButton: {
    flex: 1,
    marginLeft: 8,
    borderColor: '#009688',
  },
  conflictRecommendedButton: {
    flex: 1,
    marginHorizontal: 8,
    backgroundColor: '#009688',
  },

  // Versão alternativa com design mais integrado
validationBadgeContainer: {
  marginTop: 12,
  marginBottom: 12,
  backgroundColor: '#F1F8F4',
  borderRadius: 12,
  padding: 16,
  borderWidth: 1,
  borderColor: '#C8E6C9',
  elevation: 1,
  shadowColor: '#000',
  shadowOffset: { width: 0, height: 1 },
  shadowOpacity: 0.1,
  shadowRadius: 2,
},

validationNoticeContainer: {
  flexDirection: 'row',
  alignItems: 'center',
  marginTop: 12,
  paddingTop: 12,
  borderTopWidth: 1,
  borderTopColor: '#E0E0E0',
},
validationNoticeText: {
  fontSize: 13,
  color: '#424242',
  fontWeight: '600',
  marginLeft: 10,
  flex: 1,
  lineHeight: 18,
},

validationContactContainer: {
  flexDirection: 'row',
  alignItems: 'flex-start',
  marginTop: 10,
  backgroundColor: 'rgba(25, 118, 210, 0.08)',
  borderRadius: 8,
  padding: 12,
},
validationContactText: {
  fontSize: 13,
  color: '#0D47A1',
  fontWeight: '500',
  marginLeft: 10,
  flex: 1,
  lineHeight: 18,
  fontStyle: 'italic',
},
// Adicione ao lado dos outros estilos de card (syncedCard, cloudNewerCard, etc.)
validatedCard: {
  borderLeftColor: '#4CAF50',
  backgroundColor: '#F8FFF9',
  opacity: 0.95, // Leve transparência para indicar "bloqueado"
},
});